import { render } from "./index.vue?vue&type=template&id=97becac4&bindings={}"
import script from "./Contact.js?vue&type=script&lang=js"
export * from "./Contact.js?vue&type=script&lang=js"

import "./Contact.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script